import ReactDOM from 'react-dom'
import App from './routes/App'

//i18n init
import './i18n/i18n'
//SASS
import './assets/sass/index.scss'

ReactDOM.render(<App />, document.getElementById('root'))
